const BASE = process.env.REACT_APP_API_BASE_URL || `https://immjai-backendapi-ecs.cpfmes.com`;

export const apiUrl = {
TUMBLER_SCHEDULER_CONFIG: `${BASE}/api/tumbler-scheduler-config/`,
TUMBLER_ALLERGEN_MASTER: `${BASE}/api/tumbler-allergen-master/`,
TUMBLER_PRODUCT_MASTER: `${BASE}/api/tumbler-product-master/`,
TUMBLER_SCHEDULE_SCENARIOS: `${BASE}/api/tumbler-schedule-scenarios/`,
TUMBLER_SCHEDULE_BATCHES: `${BASE}/api/tumbler-schedule-batches/`,
// ── Tumbler Scheduling — resources / operational reads (IMPLEMENTATION_PLAN.md API mapping) ──
TUMBLER_MASTER_POTS: `${BASE}/api/tumbler-master/`,
TUMBLER_CLEANING_RULES: `${BASE}/api/tumbler-cleaning-rules/`,
TUMBLER_SETUP_ACTIVITIES: `${BASE}/api/tumbler-setup-activities/`,
TUMBLER_COLD_ROOM_RESERVATIONS: `${BASE}/api/tumbler-cold-room-reservations/`,
TUMBLER_SCHEDULE_VIOLATIONS: `${BASE}/api/tumbler-schedule-violations/`,
TUMBLER_SCHEDULE_AUDIT_LOGS: `${BASE}/api/tumbler-schedule-audit-logs/`,
TUMBLER_BARREL_ALLOCATIONS: `${BASE}/api/tumbler-barrel-allocations/`,
TUMBLER_BARREL_DISPATCHES: `${BASE}/api/tumbler-barrel-dispatches/`,
// ── Sigma Track Recipe Giveaway ───────────────────────────────────────────
SIGMA_GIVEAWAY_MASTER:   `${BASE}/api/sigma-recipe-giveaway-master/`,
SIGMA_GIVEAWAY_BASELINE: `${BASE}/api/sigma-recipe-giveaway-baseline/`,
SIGMA_GIVEAWAY_CL:       `${BASE}/api/sigma-recipe-giveaway-cl/`,
SIGMA_GIVEAWAY_MACHINE:  `${BASE}/api/sigma-recipe-giveaway-machine/`,

REFRESH_TOKEN_URL: `https://immjai-backendapi-ecs.cpfmes.com/account/token/refresh/`,
EXCHANGE_TOKEN_URL:`https://immjai-backendapi-ecs.cpfmes.com/account/exchange-token/`,
CHATBOT_CHAT: `https://immjai-backendapi-ecs.cpfmes.com/api/chatbot/chat/`,
CHATBOT_CHAT_STREAM: `https://immjai-backendapi-ecs.cpfmes.com/api/chatbot/chat/stream/`,
GET_TUMBLER_BETWEEN_2DAY: `https://immjai-backendapi-ecs.cpfmes.com/api/tumbler/`,
GET_TUMBLER_CHECK_STATUS: `https://immjai-backendapi-ecs.cpfmes.com/api/tumbler/`,
POST_INSERT_TUMBLER: `https://immjai-backendapi-ecs.cpfmes.com/api/tumbler/`,
PUT_UPDATE_TUMBLER: `https://immjai-backendapi-ecs.cpfmes.com/api/tumbler-update/`,
MASTER_BU: `https://immjai-backendapi-ecs.cpfmes.com/api/master-plant/bu`,
MASTER_PLANT: `https://immjai-backendapi-ecs.cpfmes.com/api/master-plant/`,
USER: `https://immjai-backendapi-ecs.cpfmes.com/account/user/`,
REGISTER: `https://immjai-backendapi-ecs.cpfmes.com/account/register-user/`,
MASTER_PLANT_STD: `https://immjai-backendapi-ecs.cpfmes.com/api/model-master-plant/`,
EDIT_MASTER_PLANT: `https://immjai-backendapi-ecs.cpfmes.com/api/master-plant/`,
GET_MASTER_STD: `https://immjai-backendapi-ecs.cpfmes.com/api/master-std/`,
POST_MASTER_STD: `https://immjai-backendapi-ecs.cpfmes.com/api/model-master-std/`,
UNLOCK_GIVEAWAY: `https://immjai-backendapi-ecs.cpfmes.com/api/function/giveaway/`,
GET_TUMBLER_STATUS: `https://immjai-backendapi-ecs.cpfmes.com/api/line-status/?country=Thailand&`,
PUT_TUMBLER_STATUS: `https://immjai-backendapi-ecs.cpfmes.com/api/line-status/`,
UPDATE_PO_V2: `https://immjai-backendapi-ecs.cpfmes.com/api/po/update-v2/`,
UPDATE_PO_V2_VN: `https://immjai-backendapi-ecs.cpfmes.com/api/po/update-v2-vn/`,

PERFORMANCE_PAGE1: `https://t3ttp2x2r9.execute-api.ap-southeast-1.amazonaws.com/prd/4117/fur2/api/line-monitoring/page1/line7`,
PERFORMANCE_PAGE2: `https://t3ttp2x2r9.execute-api.ap-southeast-1.amazonaws.com/prd/4117/fur2/api/line-monitoring/page2/line7`,
PERFORMANCE_LINE8_PAGE1: `https://t3ttp2x2r9.execute-api.ap-southeast-1.amazonaws.com/prd/4117/fur2/api/line-monitoring/page1/line8`,
PERFORMANCE_LINE8_PAGE2: `https://t3ttp2x2r9.execute-api.ap-southeast-1.amazonaws.com/prd/4117/fur2/api/line-monitoring/page2/line8`,
PERFORMANCE_LINE9_PAGE1: `https://t3ttp2x2r9.execute-api.ap-southeast-1.amazonaws.com/prd/4117/fur2/api/line-monitoring/page1/line9`,
PERFORMANCE_LINE9_PAGE2: `https://t3ttp2x2r9.execute-api.ap-southeast-1.amazonaws.com/prd/4117/fur2/api/line-monitoring/page2/line9`,
PERFORMANCE_LINE10_PAGE1: `https://t3ttp2x2r9.execute-api.ap-southeast-1.amazonaws.com/prd/4117/fur2/api/line-monitoring/page1/line10`,
PERFORMANCE_LINE10_PAGE2: `https://t3ttp2x2r9.execute-api.ap-southeast-1.amazonaws.com/prd/4117/fur2/api/line-monitoring/page2/line10`,

GIVEAWAY_PAGE1: `https://immjai-backend-api.cpfmes.com/4117/fur2/api/giveaway/page1/line7`,
GIVEAWAY_PAGE2: `https://immjai-backend-api.cpfmes.com/4117/fur2/api/giveaway/page2/line7`,
GIVEAWAY_LINE8_PAGE1: `https://immjai-backend-api.cpfmes.com/4117/fur2/api/giveaway/page1/line8`,
GIVEAWAY_LINE8_PAGE2: `https://immjai-backend-api.cpfmes.com/4117/fur2/api/giveaway/page2/line8`,
GIVEAWAY_LINE9_PAGE1: `https://immjai-backend-api.cpfmes.com/4117/fur2/api/giveaway/page1/line9`,
GIVEAWAY_LINE9_PAGE2: `https://immjai-backend-api.cpfmes.com/4117/fur2/api/giveaway/page2/line9`,
GIVEAWAY_LINE10_PAGE1: `https://immjai-backend-api.cpfmes.com/4117/fur2/api/giveaway/page1/line10`,
GIVEAWAY_LINE10_PAGE2: `https://immjai-backend-api.cpfmes.com/4117/fur2/api/giveaway/page2/line10`,

//// web mes korat
GET_ALL_FACTORY_DATA: `https://immjai-backendapi-ecs.cpfmes.com/api/all-factory-line/4117/`, 
GET_SAP_DATA: `https://immjai-backendapi-ecs.cpfmes.com/api/sap/data/`,
GET_SPECIFIC_LINE_DATA: `https://immjai-backendapi-ecs.cpfmes.com/api/line/4117/`,
MACHINE_RUNTIME: `https://immjai-backendapi-ecs.cpfmes.com/api/machine-runtime/4117/`,
DELETE_DEFECT: `https://immjai-backendapi-ecs.cpfmes.com/api/defect/delete/`,
DELECT_NO_EMPLOYEE: `https://immjai-backendapi-ecs.cpfmes.com/api/number-of-employee/delete/`,
GET_DEFECT: `https://immjai-backendapi-ecs.cpfmes.com/api/defect/get/4117/`,
GET_NO_EMPLOYEE: `https://immjai-backendapi-ecs.cpfmes.com/api/number-of-employee/get/4117/`,
GET_DEFECT_FOR_DONUT: `https://immjai-backendapi-ecs.cpfmes.com/api/defect/get/donut/4117/`,
ADD_DEFECT: `https://immjai-backendapi-ecs.cpfmes.com/api/add-defect/`,
EDIT_DEFECT: `https://immjai-backendapi-ecs.cpfmes.com/api/defect/update/`,
ADD_NO_EMPLOYEE: `https://immjai-backendapi-ecs.cpfmes.com/api/add-number-of-employee/`,
EDIT_NO_EMPLOYEE: `https://immjai-backendapi-ecs.cpfmes.com/api/number-of-employee/update/`,
DAILY_REPORT: `https://immjai-backendapi-ecs.cpfmes.com/api/post-date/get/4117/LINE7/`,
UPDATE_PO: `https://t3ttp2x2r9.execute-api.ap-southeast-1.amazonaws.com/prd/sap/outbound/meskr`,

CHECKEN_YARD_LINE1: `https://t3ttp2x2r9.execute-api.ap-southeast-1.amazonaws.com/prd/mes/apigw/axons-qc/slaugther/dashboard-1/407010/1`,
CHECKEN_YARD_LINE2: `https://t3ttp2x2r9.execute-api.ap-southeast-1.amazonaws.com/prd/mes/apigw/axons-qc/slaugther/dashboard-1/407010/2`,

POST_PLANT_DOWNTIME: `https://immjai-backendapi-ecs.cpfmes.com/api/schedule/`,
POST_UPDATE_PLANT_DOWNTIME: `https://immjai-backendapi-ecs.cpfmes.com/api/schedule-downtime/`,
GET_PLANT_DOWNTIME: `https://immjai-backendapi-ecs.cpfmes.com/api/schedule/?plant_id=4117&factory=00000000000000`,
PUT_PLANT_DOWNTIME_STANDALONE: `https://immjai-backendapi-ecs.cpfmes.com/api/schedule-downtime/`,
PARTIAL_UPDATE_PLAN: `https://immjai-backendapi-ecs.cpfmes.com/api/schedule/`,

GET_DEFECT_KORAT: `https://immjai-backendapi-ecs.cpfmes.com/api/defect/?plant_id=4117&factory=00000000000000`,
POST_DEFECT_KORAT: `https://immjai-backendapi-ecs.cpfmes.com/api/defect/`,


///// Nongjok

POST_UPDATE_PO: `https://server-side-mes-nongjok.com/api/po/update/`,
GET_ALL_PO: `https://server-side-mes-nongjok.com/api/po/get/`,
GET_DEFECT: `https://server-side-mes-nongjok.com/api/defect/get/4046/`,
ADD_DEFECT: `https://server-side-mes-nongjok.com/api/add-defect/`,
UPDATE_DEFECT: `https://server-side-mes-nongjok.com/api/defect/update/`,
DELETE_DEFECT: `https://server-side-mes-nongjok.com/api/defect/delete/`,
OEE: `https://server-side-mes-nongjok.com/api/oee/`,
GET_DEFECT_V2: `https://server-side-mes-nongjok.com/api/defect-v2/get/4046/`,
ADD_DEFECT_V2: `https://server-side-mes-nongjok.com/api/defect-v2/`,
UPDATE_DEFECT_V2: `https://server-side-mes-nongjok.com/api/defect-v2/update/`,
DELETE_DEFECT_V2: `https://server-side-mes-nongjok.com/api/defect-v2/delete/`,
GET_YIELD: `https://server-side-mes-nongjok.com/api/yield/`,
SKU_REALTIME: `https://server-side-mes-nongjok.com/api/po/get/no=`,
GET_DEFECT_START_END: `https://server-side-mes-nongjok.com/api/defect-v2/get-interval/4046/`,
OVERALL_OEE: `https://server-side-mes-nongjok.com/api/overall-oee/`,
REPORT_OEE: `https://server-side-mes-nongjok.com/api/date-range-oee/`,

WIP_TRACKING: `${BASE}/api/mes/master/`,
WIP_REGISTER: `${BASE}/api/mes/register/`,
WIP_MASTER: `${BASE}/api/mes/master/`,
WIP_MASTER_OPTIONS: `${BASE}/api/mes/master-options/`,
WIP_MOBILE_SCAN: `${BASE}/api/mes/mobile-scan/`
}
